// Campus photo for /colleges/princeton-university: CC BY-SA 2.0, by Ken Lund, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACannon_Green_and_Nassau_Hall%2C_Princeton_University.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/princeton-university/; credited under the photo.
const photo = {
    "slug": "princeton-university",
    "alt": "Nassau Hall behind Cannon Green at Princeton University in Princeton, New Jersey",
    "src": "/colleges/princeton-university/campus-1600.webp",
    "srcSmall": "/colleges/princeton-university/campus-800.webp",
    "srcMid": "/colleges/princeton-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/princeton-university/og.jpg",
    "title": "Cannon Green and Nassau Hall, Princeton University",
    "author": "Ken Lund",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACannon_Green_and_Nassau_Hall%2C_Princeton_University.jpg",
    "read": "2026-09-30"
};

export default photo;
